// extracted by mini-css-extract-plugin
export var docDesktopTitle = "product-support-layout-module--docDesktopTitle--e493f";
export var docGroup = "product-support-layout-module--docGroup--1a5a1";
export var docGroupList = "product-support-layout-module--docGroupList--1bdbb";
export var docGroupTitle = "product-support-layout-module--docGroupTitle--7b40a";
export var docImage = "product-support-layout-module--docImage--8e512";
export var docListContainer = "product-support-layout-module--docListContainer--33363";
export var docMobileTitle = "product-support-layout-module--docMobileTitle--4acd0";
export var docsInfo = "product-support-layout-module--docsInfo--a4a6e";
export var documentationContainer = "product-support-layout-module--documentationContainer--02a4f";
export var documentationRow = "product-support-layout-module--documentationRow--c8959";
export var faq = "product-support-layout-module--faq--6f6ce";
export var playButton = "product-support-layout-module--playButton--00410";
export var productSupportLayout = "product-support-layout-module--productSupportLayout--40e79";
export var quickTile = "product-support-layout-module--quickTile--aeb80";
export var quickTileIcon = "product-support-layout-module--quickTileIcon--ddef4";
export var quickTileImg = "product-support-layout-module--quickTileImg--7bb37";
export var quickTiles = "product-support-layout-module--quickTiles--fe789";
export var quickTilesContainer = "product-support-layout-module--quickTilesContainer--4f2f8";
export var videoContainer = "product-support-layout-module--videoContainer--526d8";
export var videoImageContainer = "product-support-layout-module--videoImageContainer--99950";
export var videos = "product-support-layout-module--videos--e20d7";
export var videosContainer = "product-support-layout-module--videosContainer--baae7";